export default "__VITE_ASSET__BbCcurnL__"